import React, { FC } from 'react';
import { Menu } from './styles';

const MenuIcon: FC = ({ ...rest }) => {
	return <Menu {...rest} />;
};

export default MenuIcon;
